import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { map, of, switchMap, take } from 'rxjs';
import { TenantAccessRepository } from '../repositories/tenant-access.repository';
import { AuthenticationService } from '../services/authentication.service';

export const redirectBrowserExtensionToTenant = (route: ActivatedRouteSnapshot) => {
    const authenticationService = inject(AuthenticationService);
    const tenantAccessRepository = inject(TenantAccessRepository);
    const router = inject(Router);

    const currentUrl = '/' + route.url.map((segment) => segment.path).join('/');
    sessionStorage.setItem('postLoginRedirect', currentUrl);

    return authenticationService.isLoggedIn().pipe(
        take(1),
        switchMap((authenticated) => {
            if (!authenticated) {
                return of(router.createUrlTree(['no-tenant']));
            }

            return authenticationService.getTenantId().pipe(
                switchMap((tenantId) =>
                    tenantAccessRepository.findByTenantIdSnapshot(tenantId).pipe(
                        take(1),
                        map((tenantAccess) => {
                            const tenantUrl = tenantAccess?.uid as string;
                            return router.createUrlTree([tenantUrl, 'browser-extensions', 'sidebar']);
                        }),
                    ),
                ),
            );
        }),
    );
};
